module.exports = __webpack_public_path__ + "static/media/bumppyloginpageimgone.06b09fb1.png";